<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('kds.settings')" class="mar-bt-0"></general-top-bar> -->
    <!--End General Top Bar -->
    <div id="outer-container">
      <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
        <div class="card-content">
          <div class="clearfix row pad-lf-10 pad-rg-10">
            <a
              class="btn btn-fill btn-primary"
              :class="{ active: isGeneral }"
              @click="openGeneral"
            >{{$t('kds.general')}}</a>
            <a
              class="btn btn-fill btn-primary"
              :class="{ active: isUsers }"
              @click="openUsers"
            >{{$t('kds.users')}}</a>
            <a
              class="btn btn-fill btn-primary"
              :class="{ active: isSections }"
              @click="openSections"
            >{{$t('kds.sections')}}</a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isGeneral">
      <div class="card">
        <div class="card-content kds-settings-columns">
          <div class="kds-settings-column">
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.startTimer')}}</label>
              <p-switch
                v-model="startTimer"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.useStartTimerForAllItems')}}</label>
              <p-switch
                v-model="useStartTimerForAllItems"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.useOrderLanes')}}</label>
              <p-switch
                v-model="useOrderLanes"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.allowOptionTimer')}}</label>
              <p-switch
                v-model="allowOptionTimer"
                type="success">
              </p-switch>
              <small>{{$t('kds.allowOptionTimerInfo')}}</small>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.allowCourseTimer')}}</label>
              <p-switch
                v-model="allowCourseTimer"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.timeProcessingStatus')}}</label>
              <p-switch
                v-model="timeProcessingStatus"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.displayOrdersGrid')}}</label>
              <p-switch
                v-model="displayOrdersGrid"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.displayOrdersMode')}}</label>
              <el-select
                v-model="displayOrdersMode"
                style="width: 100%; max-width: 280px;">
                <el-option
                  v-for="option in displayOrdersModeOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
              </el-select>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.ordersSortColumn')}}</label>
              <el-select
                v-model="ordersSortColumn"
                style="width: 100%; max-width: 280px;">
                <el-option
                  v-for="option in ordersSortColumnOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
              </el-select>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.productSorting')}}</label>
              <el-select
                v-model="productSorting"
                style="width: 100%; max-width: 280px;">
                <el-option
                  v-for="option in productSortingOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="kds-settings-column">
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.displayStartedOrdersFirst')}}</label>
              <p-switch
                v-model="displayStartedOrdersFirst"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.groupProductsByCategory')}}</label>
              <p-switch
                v-model="groupProductsByCategory"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.hidePreparedItems')}}</label>
              <p-switch
                v-model="hidePreparedItems"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.displayWaiterName')}}</label>
              <p-switch
                v-model="displayWaiterName"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.displayDeliveryTime')}}</label>
              <p-switch
                v-model="displayDeliveryTime"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.useAutoCloseOrders')}}</label>
              <p-switch
                v-model="useAutoCloseOrders"
                type="success">
              </p-switch>
              <small>{{$t('kds.useAutoCloseOrdersInfo')}}</small>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.autoPrint')}}</label>
              <p-switch
                v-model="autoPrint"
                type="success">
              </p-switch>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.notificationSound')}}</label>
              <div class="notification-sound-row">
                <el-select
                  v-model="notificationSound"
                  style="width: 100%; max-width: 280px;">
                  <el-option
                    v-for="option in notificationSoundOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value">
                  </el-option>
                </el-select>
                <button
                  type="button"
                  class="btn btn-fill btn-primary"
                  @click="playNotificationSound">
                  {{$t('kds.playSound')}}
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <BackgroundColorPicker :title="$t('kds.lane_1_color')" :color="lane1background" @color-change="updateColor($event, 'lane1background')"></BackgroundColorPicker>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <BackgroundColorPicker :title="$t('kds.lane_2_color')" :color="lane2background" @color-change="updateColor($event, 'lane2background')"></BackgroundColorPicker>
              </div>
            </div>
            <div class="form-group mar-to-15 label-input">
              <label>{{$t('kds.orderAveragePrepTime')}}</label>
              <el-time-picker
                v-model="orderAveragePrepTime"
                format="HH:mm:ss"
                @change="updatePrepTime"
                placeholder="Select time"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isUsers">
        <KdsSettingsUsers />

        <!-- <div class="card mar-to-15">
            <div class="card-content">
                <div class="text-right">
                    <p>
                        <button class="btn add mar-rt-10"  @click="goToAdd" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
                            <img src="/static/img/icons/add.png">
                            {{$t('general.add')}}
                        </button>
                    </p>
                </div>
                <data-tables
                    v-loading="loading"
                    :data="filteredTableData"
                    ref="userList"
                    :search-def="{}"
                    :pagination-def="{}"
                    :table-props="{'border': false}"
                    @row-click="goToRecord"
                    style="width: 100%">
                    <el-table-column v-for="column in tableColumns"
                                    :key="column.label"
                                    :min-width="column.minWidth"
                                    :prop="column.prop"
                                    :label="column.label"
                                    sortable>
                    </el-table-column>
                    <el-table-column :min-width="150" prop="role" :label="$t('settingUsers.role')" >
                        <template slot-scope="props">
                            {{$t('settingUsers.' + props.row.role)}}
                        </template>
                    </el-table-column>
                    <el-table-column :width="145">
                        <template slot-scope="props">
                            <div class="edit" @click="goToRecord(props.row, $event)">
                              <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                            </div>
                        </template>
                    </el-table-column>
                </data-tables>
            </div>
        </div> -->
    </div>
    <div v-if="isSections">
      <KdsSections />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import KdsSections from './Sections/KdsSections.vue'
import KdsSettingsUsers from './KdsSettingsUsers.vue'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import {Input, Table, TableColumn, Option, Pagination, TimePicker, Select} from 'element-ui'
import DataTables from 'vue-data-tables'
import PPagination from 'src/components/UIComponents/Pagination.vue'
import BackgroundColorPicker from 'src/components/UIComponents/BackgroundColorPicker.vue'

Vue.use(Input)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(DataTables)

export default {
  components: {
    // GeneralTopBar,
    PSwitch,
    KdsSections,
    KdsSettingsUsers,
    BackgroundColorPicker,
    'el-time-picker': TimePicker,
    PPagination,
    [Input.name]: Input
  },
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    openUsersProp: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      isGeneral: true,
      isUsers: false,
      isSections: false,
      useStartTimerForAllItems: false,
      startTimer: false,
      useOrderLanes: false,
      allowOptionTimer: false,
      allowCourseTimer: false,
      timeProcessingStatus: false,
      displayStartedOrdersFirst: false,
      groupProductsByCategory: false,
      hidePreparedItems: false,
      displayWaiterName: false,
      displayDeliveryTime: false,
      useAutoCloseOrders: false,
      autoPrint: false,
      notificationSound: 1,
      displayOrdersGrid: false,
      displayOrdersMode: 1,
      ordersSortColumn: 'pickup_datetime',
      productSorting: 1,
      orderAveragePrepTime: '00:00:00',
      lane1background: null,
      lane2background: null,
      tableColumns: [
        {
          prop: 'firstname',
          label: this.$t('settingUsers.fn'),
          minWidth: 100
        },
        {
          prop: 'lastname',
          label: this.$t('settingUsers.ln'),
          minWidth: 100
        }
      ],
      tableData: [],
      colors: {
        black: '#000'
      }
    }
  },
  computed: {
    filteredTableData () {
      // Filter table data to only include users with role 'KDS_OPERATOR'
      return this.tableData.filter(user => user.role === 'KDS_OPERATOR')
    },
    displayOrdersModeOptions () {
      return [
        { value: 1, label: this.$t('kds.displayOrdersModeVertical') },
        { value: 3, label: this.$t('kds.displayOrdersModeHorizontal') },
        { value: 4, label: this.$t('kds.displayOrdersModeCompactColumns') }
      ]
    },
    notificationSoundOptions () {
      return [
        { value: 1, label: this.$t('kds.sound1') },
        { value: 2, label: this.$t('kds.sound2') },
        { value: 3, label: this.$t('kds.sound3') }
      ]
    },
    ordersSortColumnOptions () {
      return [
        { value: 'pickup_datetime', label: this.$t('kds.ordersSortColumnPickup') },
        { value: 'created_at', label: this.$t('kds.ordersSortColumnCreated') }
      ]
    },
    productSortingOptions () {
      return [
        { value: 1, label: this.$t('kds.productSortingChronologic') },
        { value: 2, label: this.$t('kds.productSortingPrepTime') }
      ]
    }
  },
  mounted () {
    if (this.openUsersProp) {
      this.openUsers()
    }
  },
  created () {
    if (this.openUsersProp) {
      this.openUsers()
    }
    this.getUsers()
    this.getSettings()
  },
  watch: {
    useStartTimerForAllItems () {
      this.updateSettings()
    },
    startTimer () {
      this.updateSettings()
    },
    useOrderLanes () {
      this.updateSettings()
    },
    allowOptionTimer () {
      this.updateSettings()
    },
    allowCourseTimer () {
      this.updateSettings()
    },
    timeProcessingStatus () {
      this.updateSettings()
    },
    displayStartedOrdersFirst () {
      this.updateSettings()
    },
    groupProductsByCategory () {
      this.updateSettings()
    },
    hidePreparedItems () {
      this.updateSettings()
    },
    displayWaiterName () {
      this.updateSettings()
    },
    displayDeliveryTime () {
      this.updateSettings()
    },
    useAutoCloseOrders () {
      this.updateSettings()
    },
    autoPrint () {
      this.updateSettings()
    },
    notificationSound () {
      this.updateSettings()
    },
    displayOrdersGrid () {
      this.updateSettings()
    },
    displayOrdersMode () {
      this.updateSettings()
    },
    ordersSortColumn () {
      this.updateSettings()
    },
    productSorting () {
      this.updateSettings()
    },
    lane1background () {
      this.updateSettings()
    },
    lane2background () {
      this.updateSettings()
    }
  },
  methods: {
    openGeneral () {
      this.isGeneral = true
      this.isUsers = false
      this.isSections = false
    },
    openUsers () {
      this.isUsers = true
      this.isGeneral = false
      this.isSections = false
    },
    openSections () {
      this.isSections = true
      this.isGeneral = false
      this.isUsers = false
    },
    globalGoToRecord (row, event, path) {
      const userId = row.id
      this.$router.push(`${path}${userId}`)
    },
    goToRecord (row, event) {
      if (typeof this.callback === 'function') {
        this.callback(row.id)
      } else {
        this.globalGoToRecord(row, event, '/user/edit/')
      }
    },
    goToAdd () {
      this.$router.push({ path: '/user/add', query: { from: 'kdsSettings' } })
    },
    getUsers () {
      var self = this
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/profile', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data

          self.$nextTick(function () {
            self.loading = false
          })
        }
      })
    },
    getSettings () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/kds/settings/', 'GET', data, (response) => {
        if (response.status === true) {
          this.useStartTimerForAllItems = response.data.use_start_timer_for_all_items === true
          this.startTimer = response.data.start_timer === true || response.data.start_timer === 1 || response.data.start_timer === '1'
          this.useOrderLanes = response.data.use_order_lanes === true
          this.allowOptionTimer = response.data.allow_start_timer_per_option === true
          this.allowCourseTimer = response.data.allow_start_timer_course === true
          this.timeProcessingStatus = response.data.time_processing_status === true
          this.displayStartedOrdersFirst = response.data.display_started_orders_first === true
          this.groupProductsByCategory = response.data.group_products_by_category === true
          this.hidePreparedItems = response.data.hide_prepared_items === true
          this.displayWaiterName = response.data.display_waiter_name === true
          this.displayDeliveryTime = response.data.display_delivery_time === true
          this.useAutoCloseOrders = response.data.use_auto_close_orders === true
          this.autoPrint = response.data.auto_print === true
          const notificationSound = parseInt(response.data.notification_sound_type, 10)
          this.notificationSound = [1, 2, 3].includes(notificationSound) ? notificationSound : 1
          this.displayOrdersGrid = response.data.display_orders_grid === true
          const mode = parseInt(response.data.display_orders_mode, 10)
          this.displayOrdersMode = [1, 3, 4].includes(mode) ? mode : 1
          const sortColumn = response.data.orders_sort_column
          this.ordersSortColumn = ['pickup_datetime', 'created_at'].includes(sortColumn) ? sortColumn : 'pickup_datetime'
          const productSorting = parseInt(response.data.product_sorting, 10)
          this.productSorting = [1, 2].includes(productSorting) ? productSorting : 1
          this.orderAveragePrepTime = this.formatTime(response.data.order_average_prep_time) || '00:00:00'
          this.lane1background = response.data.lane_1_background
          this.lane2background = response.data.lane_2_background
          this.loading = false
        }
      })
    },
    formatTime (timeString) {
      const parts = timeString.split(':')
      if (parts.length === 3) {
        const date = new Date()
        date.setHours(parts[0])
        date.setMinutes(parts[1])
        date.setSeconds(parts[2])
        return date
      }
      return null
    },
    getNotificationSoundSrc (sound) {
      const soundMap = {
        1: '/static/audio/beep.mp3',
        2: '/static/audio/beep2.mp4',
        3: '/static/audio/order-alert-1.wav'
      }
      return soundMap[sound] || soundMap[1]
    },
    playNotificationSound () {
      const audio = new Audio(this.getNotificationSoundSrc(this.notificationSound))
      audio.play()
    },
    updateSettings () {
      var date = new Date(this.orderAveragePrepTime)
      var hours = String(date.getHours()).padStart(2, '0')
      var minutes = String(date.getMinutes()).padStart(2, '0')
      var seconds = String(date.getSeconds()).padStart(2, '0')

      var formattedPrepTime = `${hours}:${minutes}:${seconds}`

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        use_start_timer_for_all_items: this.useStartTimerForAllItems ? 1 : 0,
        start_timer: this.startTimer ? 1 : 0,
        use_order_lanes: this.useOrderLanes ? 1 : 0,
        allow_start_timer_per_option: this.allowOptionTimer ? 1 : 0,
        allow_start_timer_course: this.allowCourseTimer ? 1 : 0,
        time_processing_status: this.timeProcessingStatus ? 1 : 0,
        display_started_orders_first: this.displayStartedOrdersFirst ? 1 : 0,
        group_products_by_category: this.groupProductsByCategory ? 1 : 0,
        hide_prepared_items: this.hidePreparedItems ? 1 : 0,
        display_waiter_name: this.displayWaiterName ? 1 : 0,
        display_delivery_time: this.displayDeliveryTime ? 1 : 0,
        use_auto_close_orders: this.useAutoCloseOrders ? 1 : 0,
        auto_print: this.autoPrint ? 1 : 0,
        notification_sound_type: this.notificationSound,
        order_average_prep_time: formattedPrepTime,
        display_orders_grid: this.displayOrdersGrid,
        display_orders_mode: this.displayOrdersMode,
        orders_sort_column: this.ordersSortColumn,
        product_sorting: this.productSorting,
        lane_1_background: this.lane1background,
        lane_2_background: this.lane2background
      }
      this.apiRequest('/kds/settings', 'PUT', data, function (response) {
        if (response.status === true) {
        }
      })
    },
    updatePrepTime () {
      this.updateSettings()
    },
    updateColor (value, attribute) {
      this[attribute] = value
    }
  }
}
</script>

<style>
.kds-settings-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 30px;
}
.kds-settings-column {
  min-width: 0;
}
.kds-settings-column .row > .col-md-4 {
  width: 100%;
}
@media (max-width: 767px) {
  .kds-settings-columns {
    grid-template-columns: 1fr;
    gap: 0;
  }
}

.el-date-editor .el-range-separator {
  padding: 0 2px;
}
#outer-container .navButtons .card-content {
  padding-left: 0px;
}
.el-table .cell {
  height: 55px;
}
.pull-right.legend {
  margin-top: 15px;
  cursor: pointer;
  text-decoration: underline;
}
.info-text {
  font-size: 13px;
  font-weight: 400;
  color: #000;
  background-color: white;
  padding: 7px 10px;
  border-radius: 9px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.1);
}

.label-input {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.notification-sound-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/KdsSettings.vue